import api from "./api";

export default {
  // Get all mailer reports
  getAllReports() {
    return api.execute('get', '/mailer-reports');
  },

  // Get single mailer report by ID
  getReportById(_id) {
    return api.execute('get', `/mailer-reports/${_id}`);
  },

  // Create new mailer report
  createReport(data) {
    return api.execute('post', '/mailer-reports', data);
  },

  // Update existing mailer report
  updateReport(_id, data) {
    return api.execute('put', `/mailer-reports/${_id}`, data);
  },

  // Delete mailer report
  deleteReport(_id) {
    return api.execute('delete', `/mailer-reports/${_id}`);
  },

  // Toggle report status (enable/disable)
  toggleReportStatus(_id, enabled) {
    return api.execute('patch', `/mailer-reports/${_id}/toggle`, { enabled });
  },

  // Bulk status update
  bulkUpdateStatus(ids, enabled) {
    return api.execute('patch', '/mailer-reports/bulk-status', { ids, enabled });
  },

  // Send test email for a report
  sendTestEmail(_id, testRecipients) {
    return api.execute('post', `/mailer-reports/${_id}/test`, { testRecipients });
  },

  // Execute report manually (send now)
  executeReportNow(_id) {
    return api.execute('post', `/mailer-reports/${_id}/execute`, {});
  },

  // Get report execution history
  getReportHistory(_id, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/mailer-reports/${_id}/history${queryString ? '?' + queryString : ''}`;
    return api.execute('get', url);
  },

  // Clone an existing report
  cloneReport(_id) {
    return api.execute('post', `/mailer-reports/${_id}/clone`, {});
  }
};